import { Dropdown } from "../Dropdown";
import { MdFilterList } from "react-icons/md";
import Button from "../Button";
import React, { useState } from "react";
import classes from "./CollapsibleDropdown.module.css";
const CollapsibleDropdown = ({
  placeholder,
  options,
  value,
  setter = () => { },
  className,
}) => {
  const [showField, setShowField] = useState(true);
  return (
    <>
      <style jsx>
        {`
          .css-rwu4q7-control {
            box-shadow: none;
          }
        `}
      </style>

      <div className={[classes.container, className].join(" ")}>
        <Dropdown
          dropdownContainer={{ boxShadow: "none" }}
          options={options}
          value={value}
          placeholder={placeholder}
          setter={setter}
          style={{ boxShadow: "none", padding: "56px" }}
          placeholderStyle={{ whiteSpace: "nowrap" }}
          controlBg="var(--white-color)"
          leftIcon={
            <Button
              label={<MdFilterList color="var(--medium-gray)" />}
              className="button_transparent"
              onClick={() => {
                setShowField((prev) => !prev);
              }}
            />
          }
          showField={showField}
          className={[classes.dropdown, showField && classes.collapsed].join(
            " "
          )}
          leftIconClass={[, classes.border].join(" ")}
        />
      </div>
    </>
  );
};

export default CollapsibleDropdown;
